import { render, staticRenderFns } from "./LeaveTypeCreate.vue?vue&type=template&id=c00b7608"
import script from "../../controllers/leave_type/leave-type-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_type/leave-type-create.js?vue&type=script&lang=js&external"
import style0 from "./LeaveTypeCreate.vue?vue&type=style&index=0&id=c00b7608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports